var React = require('react');

function HasToBeUnderPorch (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("polyline",{"className":"cls-1","points":".36 18.57 40.42 .98 80.48 18.57","key":0}),React.createElement("polyline",{"className":"cls-1","points":"23.18 19.48 29.49 45.79 51.77 45.79 51.77 67.99","key":1}),React.createElement("line",{"className":"cls-1","x1":"29.63","y1":"45.79","x2":"23.56","y2":"68.26","key":2})])]);
}

HasToBeUnderPorch.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 80.84 68.5"};

module.exports = HasToBeUnderPorch;

HasToBeUnderPorch.default = HasToBeUnderPorch;
